import { aspenApi as api, getStrategyList } from "@aspen/services";
import { generateDataCacheKey, loadData } from "@aspen/libs";
import { useQuery } from "@tanstack/react-query";
import type { IReqStrategyList } from "@aspen/model";
import { useUpdateQueryCache } from "./useUpdateQueryCache";

/**
 * 获取strategy产品列表。
 * @param {IReqStrategyList} params - 获取strategy产品详情所需的参数。
 */
export const useFetchStrategyList = (params: IReqStrategyList) => {
  const apiPath = api.strategies.strategyList;
  const queryKey = generateDataCacheKey({ api: apiPath, params: JSON.stringify(params) });
  const cacheData = loadData<any>(queryKey);

  const { error, data, isLoading, refetch, isPlaceholderData } = useQuery({
    queryKey: [queryKey, Object.values(params)],
    placeholderData: cacheData,
    queryFn: () => {
      return getStrategyList(params).then(res => {
        if (res?.code == "0") {
          return res?.data?.rows;
        }
      });
    },
  });
  useUpdateQueryCache(queryKey, data, cacheData, isPlaceholderData);
  return { error, data, refetch, queryKey, isLoading };
};
